// Utilidades de presentación PREVELIS

export const ESTADO_STYLES = {
  "Borrador": "bg-slate-100 text-slate-600 border-slate-300",
  "Inspección en curso": "bg-blue-50 text-blue-700 border-blue-200",
  "Pendiente de revisión": "bg-amber-50 text-amber-700 border-amber-200",
  "Documentación generada": "bg-purple-50 text-purple-700 border-purple-200",
  "Emitido": "bg-blue-50 text-blue-800 border-blue-200",
  "En revisión": "bg-yellow-50 text-yellow-700 border-yellow-200",
  "Archivado": "bg-slate-50 text-slate-600 border-slate-200",
};

export function formatFecha(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return "—";
  }
}

export function formatFechaHora(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("es-ES", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "—";
  }
}
